import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../@shared/services/common.service';
//declare var $: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit {

  constructor(public _common: CommonService, public router: Router) {}

  ngOnInit(): void {
    // $('#SideMenu a').click((e: any) => {
    //   $('#SideMenu .collapse').collapse('hide');
    // });

    // $(() => {
    //   $('[data-toggle="tooltip"]').tooltip()
    // });

    // $(() => {
    //   $('.button-menu-mobile').on("click", () => {
    //     $('body').addClass("sidebar-enable");
    //   });
    // });

    // $(() => {
    //   $('.menuClose').on("click", () => {
    //     $('body').removeClass("sidebar-enable");
    //   });
    // });
  }

  // ngDoCheck() {
  //   let expireTime = (localStorage.getItem(`${environment.panel}expiry`)) ? new Date(localStorage.getItem(`${environment.panel}expiry`) as any) : new Date();
  //   let currentTime = new Date();

  //   if (currentTime > expireTime || currentTime.getTime() > expireTime.getTime()) {
  //     this._common.removeLocalstorage();
  //     this.router.navigate(['/home']);

  //   }
  // }
}
